export default __webpack_public_path__ + "static/media/multiple-response-blue.b791ae77.svg";